import { BasicResult } from "../basic-result";
import { UserAudit } from "./user-audit";

export class UserAuditResult extends BasicResult{
    public Users: UserAudit[] = [];

    constructor(values: Object = {}) {
                super();
        Object.assign(this, values);
        if (values.hasOwnProperty('UserAudits')) {
            this.Users = [];
            ((values as UserAuditResult)['Users'] as UserAudit[]).forEach(element => {
                this.Users.push(new UserAudit(element));
            });
        }
    }
}